module.exports = __webpack_public_path__ + "img/gerüstbohlen-tisch-konfigurieren-m02.1511f49c.jpeg";